const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export function validEmail(email) {
    if (!email) {
        return false;
    }
    return emailRegexp.test(email.trim());
}
// Added EH7Irv to make the id unique enough to avoid collisions with other ids in the email
export const requestAvailabilityBlockId = "request-availability-EH7Irv";
export function getRequestAvailabilityBlockHtml(availabilityLink) {
    return `<div id="${requestAvailabilityBlockId}"><p style="font-size: 14px; color: #666;"><i>Want an easier way to let us know about your current openings?</i><br><a ${availabilityLink ? `href="${availabilityLink}"` : ""}>Share Your Current Openings</a></p></div>`;
}
export const emailTokens = {
    liveLink: "{{link}}",
};
export const extractEmailDomain = (email) => {
    if (!email || typeof email !== "string") {
        return "";
    }
    const [_, domain] = email.split("@");
    if (!domain) {
        return "";
    }
    return domain.toLocaleLowerCase();
};
export const extractFirstName = (name) => {
    if (!name || typeof name !== "string") {
        return "";
    }
    const token = name.split(" ")[0].trim().toLocaleLowerCase();
    if (token.length > 0) {
        return token[0].toUpperCase() + token.slice(1);
    }
    return "";
};
export const sentMessageTypeValues = [
    "ClientIntake",
    "ClientIntakeFax",
    "CommunityComparison",
    "Email",
    "Invoice",
    "DisclosureRequest",
    "DisclosureReceipt",
    "HostedFormRequest",
    "HostedFormReferralLink",
    "SignatureRequest",
    "SignatureCompletion",
    "TestOnlyMessage",
    "BulkMessage",
    "AvailabilityRequest",
];
export const defaultEmailStyleString = "font-size: medium; line-height: 1.5;";
export var ExternalEmailProvider;
(function (ExternalEmailProvider) {
    ExternalEmailProvider["Ses"] = "Ses";
    ExternalEmailProvider["SendGrid"] = "SendGrid";
})(ExternalEmailProvider || (ExternalEmailProvider = {}));
export const messageTypeRegistry = {
    ClientIntake: {
        tokens: {},
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    ClientIntakeFax: {
        tokens: {},
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    CommunityComparison: {
        tokens: {
            link: {
                humanFriendlyName: "Live link",
                description: "Live link to community comparison",
            },
        },
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    Email: {
        tokens: {},
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    Invoice: {
        tokens: {},
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    DisclosureRequest: {
        tokens: {
            link: {
                humanFriendlyName: "Disclosure link",
                description: "Link to complete disclosure",
            },
        },
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    DisclosureReceipt: {
        tokens: {},
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    HostedFormRequest: {
        tokens: {
            link: {
                humanFriendlyName: "Hosted form link",
                description: "Link to complete hosted form",
            },
        },
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    SignatureRequest: {
        tokens: {
            link: {
                humanFriendlyName: "Sign document link",
                description: "Link to complete signature",
            },
        },
        userSelectableTemplate: false,
        usesTemplateSubject: true,
        defaultSubject: "Your signature is requested",
        defaultTemplateFilename: "signature-request.html.hbs",
        allowDirectSMTP: false,
    },
    SignatureCompletion: {
        tokens: {},
        userSelectableTemplate: false,
        usesTemplateSubject: true,
        defaultSubject: "Signed document available",
        defaultTemplateFilename: "signature-completion.html.hbs",
        allowDirectSMTP: false,
    },
    TestOnlyMessage: {
        tokens: {
            link: {
                humanFriendlyName: "Sign document link",
                description: "Link to complete signature",
            },
        },
        userSelectableTemplate: true,
        usesTemplateSubject: true,
        defaultSubject: "Hello world",
        defaultTemplateFilename: "test-message-body.html.hbs",
        allowDirectSMTP: true,
    },
    BulkMessage: {
        tokens: {},
        userSelectableTemplate: true,
        usesTemplateSubject: true,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    HostedFormReferralLink: {
        tokens: {
            link: {
                humanFriendlyName: "Hosted form's referral link",
                description: "Link to complete hosted form linked to referral",
            },
        },
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
    AvailabilityRequest: {
        tokens: {
            link: {
                humanFriendlyName: "Link to enroll in availability",
                description: "Link to complete enrollment in availability",
            },
        },
        userSelectableTemplate: false,
        usesTemplateSubject: false,
        defaultSubject: "",
        defaultTemplateFilename: "",
        allowDirectSMTP: true,
    },
};
//# sourceMappingURL=email.js.map